var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 17.611,
    viewBox: "0 0 18 17.611",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1771",
    "data-name": "Rectangle 1771",
    width: 18,
    height: 17.611,
    transform: "translate(0 0)",
    fill: "#610D24"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2651",
    "data-name": "Group 2651",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1322",
    "data-name": "Path 1322",
    d: "M18,70.633v.556H0v-.556A9.244,9.244,0,0,1,5.318,62.22a5.682,5.682,0,0,0,.532.371,5.749,5.749,0,0,0,.65.35,5.992,5.992,0,0,0,5,0,5.861,5.861,0,0,0,.651-.35,5.682,5.682,0,0,0,.532-.371A9.244,9.244,0,0,1,18,70.633",
    transform: "translate(0 -53.578)",
    fill: "#610D24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1323",
    "data-name": "Path 1323",
    d: "M44.446,3.913A3.913,3.913,0,1,1,40.533,0a3.916,3.916,0,0,1,3.913,3.913",
    transform: "translate(-31.533 0)",
    fill: "#610D24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedPerson);
export default __webpack_public_path__ + "static/media/selected_person.493fbab1acc96ccc554f0d81349ec299.svg";
export { ForwardRef as ReactComponent };